import axios from 'axios';

const authAxios = axios.create({
  baseURL: 'https://cms.stv.mts.ru/external-api/v3',
  timeout: 5000
});

export default authAxios;
